import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Keyboard, Autoplay, Pagination, Thumbs } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

import * as PackeryModule from 'packery';
import imagesLoaded from 'imagesloaded';

import './index.pcss';
import 'swiper/swiper.css';

const Packery: any = PackeryModule;

document.addEventListener('alpine:init', () => {
    Alpine.data('initInspiration', () => {
        return {
            swiperThumb: null as Swiper | null,
            shown: false,
            showPopin: false,
            swiper: null as Swiper | null,
            activeIndex: 0,
            init () {
                const swiperParamsThumb: SwiperOptions = {
                    modules: [Navigation, Keyboard],
                    spaceBetween: 8,
                    slidesPerView: 'auto',
                    freeMode: true,
                    watchSlidesProgress: true,
                    keyboard: {
                        enabled: true
                    },
                    navigation: {
                        prevEl: this.$refs.buttonThumbPrev,
                        nextEl: this.$refs.buttonThumbNext
                    }
                };

                const swiperThumb = new Swiper(
                    this.$refs.swiperContainerThumb,
                    swiperParamsThumb
                );
                this.swiperThumb = swiperThumb;

                const swiperParams: SwiperOptions = {
                    modules: [Autoplay, Navigation, Keyboard, Pagination, Thumbs],
                    init: false,
                    loop: false,
                    autoplay: false,
                    spaceBetween: 0,
                    centeredSlides: true,
                    slidesPerView: 1,
                    keyboard: {
                        enabled: true
                    },
                    thumbs: {
                        swiper: swiperThumb
                    },
                    navigation: {
                        prevEl: this.$refs.buttonPrev,
                        nextEl: this.$refs.buttonNext
                    }
                };

                const swiper = new Swiper(
                    this.$refs.swiperContainer,
                    swiperParams
                );
                this.swiper = swiper;
                this.$nextTick(() => {
                    swiper.init();
                    swiperThumb.init();

                    this.initGrid();
                });
            },
            openSliderToCurrentPicture (pictureIndex) {
                this.showPopin = true;
                this.swiper?.slideTo(pictureIndex, 0, false);
            },

            initGrid () {
                const grid = document.querySelector('.grid-inspiration');
                const isFlex = grid?.classList.contains('js-grid-flex');
                // initialize with element
                imagesLoaded(grid, () => {
                    if (grid != null) {
                        const pckry = new Packery(grid, {
                            itemSelector: '.grid-item',
                            gutter: isFlex ? 8 : 16,
                            percentPosition: false
                        });

                        pckry.layout();
                    }
                });

                window.addEventListener('resize', () => {
                    (window as any).pckry?.layout();
                });
            }

        };
    });
});
